import {useTaskActorSid} from '@api/tasks/hooks';
import {IS_MOCK} from '@api/mock-mode';
import {canManageTask, canSetTaskStatus, type TaskActor} from '@entities/task';
import type {Task, TaskStatus} from '@entities/task/model/types';

/** Пояснение запрета завершать чужую задачу в интерфейсе менеджера. */
export const TASK_FINALIZE_DENIED =
  'Только создатель может завершить задачу или вернуть её на доработку';
/** Пояснение запрета удалять чужую задачу в интерфейсе менеджера. */
export const TASK_DELETE_DENIED =
  'Вы можете удалять только задачи, созданные вами';

/** Общие UI-права формы и канбана: серверные permissions либо участие в mock-задаче. */
export const useTaskPermissions = () => {
  const userSid = useTaskActorSid();
  const actor: TaskActor = {userSid: IS_MOCK ? userSid : undefined};
  return {
    canEdit: (task: Task) => canManageTask(task, actor),
    canComment: (task: Task) =>
      task.permissions?.canComment ??
      Boolean(
        actor.userSid &&
        [task.creatorUserSid, task.managerId, task.observerUserSid].includes(
          actor.userSid,
        ),
      ),
    canDelete: (task: Task) =>
      task.permissions?.canDelete ?? canManageTask(task, actor),
    canFinalize: (task: Task) => canManageTask(task, actor),
    canSetStatus: (task: Task, status: TaskStatus) =>
      canSetTaskStatus(task, status, actor),
  };
};
